import api from '@axios'

export default {
   deleteAllCookies() {
   
      
    var cookies = document.cookie.split(";");
    document.cookie ="stm_session=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    document.cookie ="XSRF-TOKEN=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    document.cookie ="laravel_session=;expires=Thu, 01 Jan 1970 00:00:00 GMT";

     //console.log('deleteAllCookies')
    //  const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;   
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }

    // for (var c = 0; c < cookies.length; c++) {
    //   const cookie = cookies[c];
      
    //   const eqPos = cookie.indexOf("=");
    //   const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    //     var d = window.location.hostname.split(".");
    //     while (d.length > 0) {
    //       console.log('cooke name deleted',name)
    //         var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
    //         var p = location.pathname.split('/');
    //         document.cookie = cookieBase + '/';
    //         while (p.length > 0) {
    //            // document.cookie = cookieBase + p.join('/');
    //            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    //             //document.cookie = 'deleted' + p.join('/');
    //             p.pop();
    //         };
    //         d.shift();
    //     }
    // }
},

  getCookie() {
    //this.deleteAllCookies()
    return api.get('/csrf-cookie');
  }
}
